import { IconContent } from '@icons';

export const wifi: IconContent = {
    md: '<path d="M3 21V3h18v18H3Zm1-2v1h16V4H4v15Z"/><path d="M13.3 14.7a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0Z"/><path d="M12 11.2c-1 0-2 .4-2.6 1.1l-.8-.6a4.5 4.5 0 0 1 6.8 0l-.8.6a3.5 3.5 0 0 0-2.6-1.1Z"/><path d="M12 8.5c-1.8 0-3.4.8-4.5 2l-.7-.7a7.1 7.1 0 0 1 10.4 0l-.7.7a6.1 6.1 0 0 0-4.5-2Z"/>',
};
